import React, { Suspense } from "react";
import { hot } from "react-hot-loader";
import styled, { createGlobalStyle } from "styled-components";

import Main from "./Main";
import srcSpinner from "./assets/images/blue-spinner.gif";
import ErrorBoundary from "./domain/ErrorBoundary/ErrorBoundary";

const Loader = styled.img`
  width: 101px;
  height: 101px;
`;

const Center = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const GlobalStyle = createGlobalStyle`
  html {
    font-family: sans-serif;
    /* background: #E5E5E5; */
  }
  body {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
  }

  ::-webkit-scrollbar-thumb {
    background: var(--scroll-bg);
  }
`;

const App = (): JSX.Element => (
  <React.StrictMode>
    <GlobalStyle />
    <ErrorBoundary message="Sorry... something went wrong">
      <Suspense
        fallback={
          <Center>
            <Loader src={srcSpinner} />
          </Center>
        }
      >
        <Main />
      </Suspense>
    </ErrorBoundary>
  </React.StrictMode>
);

export default hot(module)(App);
